import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const studentCertificatesManagement = createApi({
    reducerPath: "studentCertificatesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        studentCertificateList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/student-certificates`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewStudentCertificate: builder.mutation({
            query: (certificateId) => ({
                url: `v1/${locale}/settings/student-certificates/${certificateId}`,
                method: "GET",
            }),
        }),

        addStudentCertificate: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/student-certificates`,
                method: "POST",
                body: body,
            }),
        }),

        updateStudentCertificate: builder.mutation({
            query: ({ body, certificateId }) => ({
                url: `v1/${locale}/settings/student-certificates/${certificateId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteStudentCertificate: builder.mutation({
            query: (certificateId) => ({
                url: `v1/${locale}/settings/student-certificates/${certificateId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useStudentCertificateListMutation,
    useDeleteStudentCertificateMutation,
    useAddStudentCertificateMutation,
    useViewStudentCertificateMutation,
    useUpdateStudentCertificateMutation,
} = studentCertificatesManagement;
